import { airServerErrorFrom } from '@/lib/error-handling.js';

const studentSessionAlreadyExistsMessage =
  'A session already exists for one or more of these students during the selected time range';

/**
 * Toast content for class-generation failures. Overlap conflicts share `message: 'bad_request'`,
 * so the user-facing text is what identifies this specific case.
 */
export function sessionGenerationErrorToast(
  error: unknown,
  fallbackTitle: string,
  fallbackDescription?: string,
): { title: string; description: string | undefined; variant: 'destructive' } {
  const airServerError = airServerErrorFrom(error);
  const description = airServerError?.userFacingMessage ?? airServerError?.message ?? fallbackDescription;

  return {
    title: description === studentSessionAlreadyExistsMessage ? 'Failed to create session' : fallbackTitle,
    description,
    variant: 'destructive',
  };
}
